import { User } from '../models';

export const AUTH_FEATURE_NAME = 'pl-auth';

export type AuthState = 'init' | 'pending' | 'success' | 'error';

export interface PLAuthState {
  currentUser?: User;
  token?: string;
  authState?: AuthState;
  hijacked?: boolean;
  isSiriusEnabled?: boolean; // Added to support pure reducer
}
